module.exports = __webpack_public_path__ + "img/icons-chair_on.229cbb24.png";